import { forwardRef, ReactNode, Ref } from 'react'
import Link from 'next/link'
import { ChevronIcon, Text } from '@instabox/consumer-web-ui'

import styles from './faqLink.module.scss'

export interface FAQLinkProps {
  href: string
  children?: ReactNode | undefined
}

const FAQLink = ({ href, children }: FAQLinkProps, ref: Ref<HTMLAnchorElement>) => {
  return (
    <Link href={href} ref={ref} className="no-underline">
      <Text className={styles.linkText}>
        <span className="mr-2">{children}</span>
        <span className={styles.icon}>
          <ChevronIcon direction="right" />
        </span>
      </Text>
    </Link>
  )
}

export default forwardRef(FAQLink)
